module.exports = __webpack_public_path__ + "img/tasks.77301241.svg";